import React, { useState, useEffect } from "react";
import "../../styles/TrainingSummaryModal.css";

const TrainingSummaryModal = ({
                                  isOpen,
                                  onClose,
                                  onSave,
                                  initialSummary = "",
                                  initialRecommendations = "",
                                  isEditing = false
                              }) => {
    const [summary, setSummary] = useState(initialSummary);
    const [recommendations, setRecommendations] = useState(initialRecommendations);

    // ✅ Update modal fields when it's opened for editing
    useEffect(() => {
        if (isOpen) {
            setSummary(initialSummary);
            setRecommendations(initialRecommendations);
        }
    }, [isOpen, initialSummary, initialRecommendations]);

    // ✅ Reset modal when closing
    const handleClose = () => {
        setSummary("");
        setRecommendations("");
        onClose();
    };

    return isOpen ? (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>{isEditing ? "Edytuj Zalecenie" : "Dodaj Zalecenie"}</h2>
                <textarea
                    placeholder="Podsumowanie..."
                    value={summary}
                    onChange={(e) => setSummary(e.target.value)}
                />
                <textarea
                    placeholder="Zalecenia..."
                    value={recommendations}
                    onChange={(e) => setRecommendations(e.target.value)}
                />
                <div className="modal-buttons">
                    <button className="cancel-btn" onClick={handleClose}>Anuluj</button>
                    <button className="save-btn" onClick={() => onSave(summary, recommendations)}>Zapisz</button>
                </div>
            </div>
        </div>
    ) : null;
};

export default TrainingSummaryModal;